import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import Helmet from 'react-helmet'
import sanitizeHtml from 'sanitize-html'

// Components
import NotFound from './NotFound'
import Loader from './utils/Loader'

// State
import { getContent } from '../store/actions/content'

class ContentPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            permalink: props.match.params.permalink,
        }
    }

    static initialAction(store, props) {
        let permalink = props.params ? props.params.permalink : props.match.params.permalink
        let res = store !== null ? getContent(permalink) : props.getContent(permalink)
        return res
    }

    componentDidMount() {
        if (isEmpty(this.state.data)) {
            ContentPage.initialAction(null, this.props)
        }
    }

    componentDidUpdate(nextProps) {
        if (nextProps.match.params.permalink !== this.props.match.params.permalink) {
            ContentPage.initialAction(null, this.props)
        }
    }

    render() {
        const { isLoading, errors, data } = this.props.content

        let helmet = null

        let title = ''
        if (this.props.siteInfo.site) {
            title += this.props.siteInfo.site.title
        }
        if (data.title) {
            if (title !== '') title += ' | '
            title += data.title
        }

        helmet = (
            <Helmet>
                <title>{title}</title>
                <meta property="og:title" content={title} />
                <meta property="og:description" content={title} />
                <meta property="twitter:title" content={title} />
            </Helmet>
        )

        return (
            <div>
                {/* LOADING */}
                {isLoading ? (
                    <div className="pt2 pb2">
                        <Loader />
                    </div>
                ) : (
                        // ===================================
                        //  Error
                        // ===================================
                        !isEmpty(errors) ? (
                            <div className="body_container padded_top padded_bottom">
                                <div className="error">
                                    {Object.keys(errors).map(key => {
                                        return <div key={key}>{errors[key]}</div>
                                    })}
                                </div>
                            </div>
                        ) : (
                                // ===================================
                                //  Not Found
                                // ===================================
                                isEmpty(data) ? (
                                    <NotFound />
                                ) : (
                                        // ===================================
                                        //  Content
                                        // ===================================
                                        <div className="body_container padded_top padded_bottom">
                                            {helmet}
                                            <h1>{data.title}</h1>
                                            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.content) }} />
                                        </div>
                                    )
                            )
                    )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        siteInfo: state.siteInfo,
        content: state.content
    }
}

export default connect(mapStateToProps, { getContent })(ContentPage)



// WEBPACK FOOTER //
// ./src/components/ContentPage.js